import React from "react";
import { inject, observer } from "mobx-react";
import classnames from 'classnames';
import { BrowserRouter as Router, Route, withRouter, Switch, RouteComponentProps } from "react-router-dom";
import { registerMicroApps, start, setDefaultMountApp, RegistrableApp } from "qiankun";
import { ConfigProvider, Spin, Layout, Modal } from "antd";
import QIANKUN_CONFIG from "@/common/js/qiankunConfig";
import { getCookie, deleteUrlSearchParam } from '@/common/utils/commonFunc'
import { COMMON_PATH } from "@/common/js/const"
import SuperOmega, { trackClickEvent, getOmegaInstance, traceCommonEvent } from '@/common/js/omega'
import { bigC_login_data, waterMarkConfig } from '@/common/js/propsInfo'
import Nav from "@/components/navMenu";
import noPermission from "@/components/noPermission";
// import watermark from 'watermark-dom'
import CommonStore, { Country } from '@/stores/commonStore';
// import Feedback from "@/components/feedback";
import "./index.less";

declare global {
  interface Window {
    waterMark: any;
  }
}
const { Content } = Layout;
const microAppsList: RegistrableApp<{}>[] = []
// 主应用的生命周期
const mainLifeCycles = {
  beforeLoad: [
    (app: any) => {
      console.log("[LifeCycle] before load %c%s", "color: green;", app.name);
      return Promise.resolve();
    }
  ],
  beforeMount: [
    (app: any) => {
      console.log("[LifeCycle] before mount %c%s", "color: green;", app.name);
      return Promise.resolve();
    }
  ],
  afterMount: [
    (app: any) => {
      console.log("[LifeCycle] after mount %c%s", "color: green;", app.name);
      return Promise.resolve();
    }
  ],
  afterUnmount: [
    (app: any) => {
      console.log(
        "[LifeCycle] after unmount %c%s",
        "color: green;",
        app.name
      );
      return Promise.resolve();
    }
  ]
}

interface RoutersProps extends RouteComponentProps {
  CommonStore?: typeof CommonStore;
}

@inject('CommonStore')
@observer
class Routers extends React.Component<RoutersProps, any> {
  callInfo: any = {};
  curCountryCode: string = '';
  showWarning: boolean = false;
  currorganizationId: number = 1;
  preTime: number = 0;
  currTime: number = 0;
  constructor(props: RoutersProps) {
    super(props);
    this.state = {
      loading: false,
      collapsed: true,
    };
  }

  componentDidMount() {
    // watermark.init(waterMarkConfig);
    window.waterMark(waterMarkConfig);
    this.props.CommonStore!.initSettings().then(() => {
      if (window.location.pathname.includes('no-permission')) {
        /** 预期内，无权限页面刷新 */
        traceCommonEvent('refresh_no_permission');
        return Promise.reject()
      }
      if (!this.props.CommonStore!.allCountry.length) {
        window.location.href = window.location.origin + '/fe/no-permission';
         /** 预期内，进去无权限页面刷新 */
        traceCommonEvent('no_permission');
        return Promise.reject()
      }
      return Promise.resolve()
    }).then(() => {
      // 初始化微应用
      QIANKUN_CONFIG.map((site) => {
        let login_data = {}
        if (site.name === 'BigC') {
          login_data = bigC_login_data
        }
        let countryList: Country[] = []
        if (site.name === 'cs-tool-system') {
          countryList = this.props.CommonStore!.allCountry
        }
        let microAppsParams = {
          name: site.name,
          entry: site.entry,
          container: "#subapp-container",
          loader: (loading: boolean) => {
            this.loadingChange(loading)
          },
          activeRule: `${COMMON_PATH}${site.activeRule}`,
          props: {
            SuperOmega,
            getOmegaInstance,
            login_data,
            countryList,
            newNav: true,
          }
        }
        return microAppsList.push(microAppsParams)
      })
      registerMicroApps(microAppsList, mainLifeCycles);
      // setDefaultMountApp('/fe/ark_fe');
      if(document.domain.includes("sim")){
        // setDefaultMountApp('/cross/fe/ticket/ark_fe#/ark/work-bench-list');
      }else{
        setDefaultMountApp(`/fe/ticket/ark_fe?lang=${getCookie("lang")}#/ark/work-bench-list`);
      }
      
      start({});
      this.handleIviewTable()
      this.props.history.listen((route: { pathname: any; }) => {
        trackClickEvent('OMGH5PageView', {
          pathname: route.pathname
        })
      })
      // 切换页面需重新检查cookie是否有修改，有则需要提示且刷新
      this.tagReloadPage()
    }).catch(err => {
      traceCommonEvent('init_failed');
    })
  }

  componentWillUnmount() {
    document.removeEventListener('mousewheel', this.eventListener)
  }

  onCollapse = (collapsed: boolean) => {
    this.setState({ collapsed });
  }

  S4 = () => {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  getUuid = () => {
    return (this.S4() + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4());
  }

  tagReloadPage = () => {
    if (document.hidden !== undefined && window.self === window.top) {
      document.addEventListener('visibilitychange', () => {
        this.curCountryCode = this.props.CommonStore!.Cookies.canonical_country_code;
        this.currorganizationId = this.props.CommonStore!.Cookies.organization_id;
        if (document.hidden === false) {
          if (getCookie('canonical_country_code') !== this.curCountryCode && this.curCountryCode) {
            this.InfoChangeWarning()
          }
          if (getCookie('organization_id') !== this.currorganizationId && this.currorganizationId) {
            this.InfoChangeWarning()
          }
        }
      })
    }
  }

  // tab 切换后信息改变  warning
  InfoChangeWarning = () => {
    if (this.showWarning === true) {
      return
    } else {
      this.showWarning = true
      Modal.warning({
        title: null,
        content: this.props.CommonStore!.curLocales.infoChange,
        okText: this.props.CommonStore!.curLocales.refreshPage,
        onOk: () => { this.reloadPage() }
      });
    }
  }

  reloadPage = () => {
    this.showWarning = false
    let jumpUrl = deleteUrlSearchParam(window.location.href, 'organization_id')
    jumpUrl = deleteUrlSearchParam(jumpUrl, 'canonical_country_code')
    window.location.href = jumpUrl
    window.location.reload();
  }

  loadingChange = (loading: boolean) => {
    this.setState({ loading });
  }

  // 擎天柱中 iview table 设置了左浮动或者右浮动，在微前端只能左右滚动，无法上下滚动，做兼容处理
  handleIviewTable() {
    if (window.location.pathname.indexOf('optimus') > -1) {
      if (document.addEventListener) {
        this.preTime = 0 // 间隔300ms检查一次
        this.currTime = 0
        document.addEventListener('mousewheel', this.eventListener, false);
      }
    }
  }

  eventListener = (event: any) => {
    this.currTime = new Date().getTime()
    if (this.currTime - this.preTime > 300) {
      this.preTime = this.currTime
      let doms = document.getElementsByClassName('ivu-table-overflowX')
      if (Math.abs(event.wheelDeltaX) > Math.abs(event.wheelDeltaY)) {
        if (doms.length > 0 && doms[0].className.indexOf('ivu-table-cancel-overflow') > -1) {
          doms[0].className = 'ivu-table-body ivu-table-overflowX'
        }
      }
      if (Math.abs(event.wheelDeltaX) < Math.abs(event.wheelDeltaY)) {
        if (doms.length > 0 && doms[0].className.indexOf('ivu-table-cancel-overflow') === -1) {
          doms[0].className += ' ivu-table-cancel-overflow'
        }
      }
    }
  }

  render() {
    const { loading, collapsed } = this.state;
    return (
      <ConfigProvider direction={getCookie('lang') === 'ar-EG' ? 'rtl' : 'ltr'}>
        <Router basename={COMMON_PATH}>
          <Switch>
            <Route path="/no-permission" component={noPermission} />
            <Route path="/" >
              <Nav onCollapse={this.onCollapse} collapsed={collapsed} />
              <Layout className={classnames('site-layout', {
                'collapsed': collapsed
              })}>
                <Content className={
                  classnames('site-layout-background',
                  // { 'working-status': this.props.CommonStore!.permissionsObj.working_status_bar }
                  )}>
                  <Spin spinning={loading} >
                    <main id="subapp-container"></main>
                  </Spin>
                </Content>
              </Layout>
              {/* 反馈入口 */}
              {/* <Feedback /> */}
            </Route>
          </Switch>
        </Router>
      </ConfigProvider>
    );
  }
}
export default withRouter(Routers);
